import React, { ReactNode } from 'react';
import { StyledFormLabel } from './styles';

interface IFormLabel {
  name: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  noWrap?: boolean;
  tooltip?: ReactNode;
  style?: any;
}

const FormLabel = ({
  name,
  label,
  disabled,
  required,
  noWrap,
  tooltip,
  style,
}: IFormLabel) => (
  <StyledFormLabel htmlFor={name} disabled={disabled} noWrap={noWrap} style={{ ...style }}>
    {label}
    {required && !disabled ? '*' : ''}
    {tooltip}
  </StyledFormLabel>
);

export default FormLabel;
